import React from 'react';
import BrandHeader from '@/components/brand/BrandHeader';

/**
 * Every role's home: the green header band, then the page on a light
 * green sheet whose rounded top edge overlaps the band. The sections inside
 * run in the same order for every role: people circles, search, latest
 * deals, my statistics, tiles.
 */
export default function HomeShell({ children }) {
  return (
    <div className="p-4 pt-3 bg-farm-mint min-h-screen">
      <BrandHeader />
      <div className="-mx-4 px-4 pt-4 -mt-5 relative rounded-t-3xl bg-farm-mint">
        {children}
      </div>
    </div>
  );
}
